import React from 'react';

import styled from 'styled-components';
import { colors, fontSize } from '@grnhse/seedling/lib/azalea/constants';

type Props = {
  url: string;
  title: string;
  subtitle: string;
};

const RecentlyViewedItem = (props: Props) => (
  <Item>
    <Link href={props.url}>
      <Title className="pii-blur" title={props.title}>
        {props.title}
      </Title>
      <Subtitle title={props.subtitle}>{props.subtitle}</Subtitle>
    </Link>
  </Item>
);

const Title = styled.div`
  font-size: ${fontSize.large};
  color: ${colors.darkestGrey};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const Subtitle = styled.div`
  font-size: ${fontSize.small};
  color: ${colors.darkGrey};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const Link = styled.a`
  box-sizing: border-box;
  line-height: 1.25rem;
  height: 100%;
  width: 100%;
  display: block;
  padding: 12px 17px;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
`;

const Item = styled.li`
  border-bottom: 1px solid ${colors.lighterGrey};

  &:hover {
    background: ${colors.babyBlue};
  }
`;

export default RecentlyViewedItem;
